export default __webpack_public_path__ + "static/media/computerla.526efbd5.jpg";